/**
 * Central polling cadences (ms) for TanStack Query `refetchInterval`. Every
 * feature hook uses one of these four tiers so refresh behaviour is intentional
 * and documented rather than ad-hoc per file:
 *
 * - REALTIME — sub-10s surfaces that emulate a live feed (threat ticker).
 * - FAST     — operational state that changes constantly (queue, active alerts).
 * - DEFAULT  — investigation lists and dashboards (most security surfaces).
 * - SLOW     — slow-moving aggregates (statistics, quarantine, rule catalogues).
 */
export const POLL_REALTIME = 5_000;
export const POLL_FAST = 15_000;
export const POLL_DEFAULT = 30_000;
export const POLL_SLOW = 60_000;
